import React, { useState } from 'react';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { PauseBillingDetailsFooter } from '../../../shared';
import { useSupportActions } from '../../../../context';

/**
 * Component that displays the technical issues pause confirmation with support form
 * Shows after user pauses due to technical issues with a form to get help
 */
const TechnicalIssuesPauseConfirmation = () => {
  // Get actions from context
  const { submitSupport } = useSupportActions();
  const [supportMessage, setSupportMessage] = useState('');

  const [processing, setProcessing] = useState(false);

  const handleSubmit = () => {
    setProcessing(true);
    if (supportMessage.trim()) {
      submitSupport(supportMessage);
      setSupportMessage('');
    }
  };

  const isSubmitDisabled = !supportMessage.trim() || processing;

  return (
    <div className="technical-issues-pause-confirmation-content">
      <div className="mb-4">
        <h5 className="mb-4">Your billing is paused, and we're here to help.</h5>

        <p className="mb-3">
          We've paused your billing period for 30 days. You'll keep full access to your WHOLE Life Club membership while
          our Support Team helps you get everything running smoothly.
        </p>

        <p className="mb-4">
          To make sure we can fix things quickly, please share a few details below. On business days, we can usually
          respond within a few hours.
        </p>

        <FormGroup className="text-left mb-4">
          <Label for="supportMessage" className="font-weight-bold">
            How can we help?
          </Label>
          <Input
            type="textarea"
            id="supportMessage"
            value={supportMessage}
            onChange={e => setSupportMessage(e.target.value)}
            placeholder="Please describe the technical issue you're experiencing..."
            rows="4"
            className="mt-2"
          />
        </FormGroup>

        <div className="mb-4">
          <Button color="primary" onClick={handleSubmit} disabled={isSubmitDisabled} className="mb-3">
            {processing ? 'Loading...' : 'Submit'}
          </Button>
        </div>

        <PauseBillingDetailsFooter className="billing-details" />
      </div>
    </div>
  );
};

export default TechnicalIssuesPauseConfirmation;
